/**
 * Created by wczeng on 2021/6/3.
 */
import Vuex from 'vuex'
import Vue from 'vue'
import * as types from './types'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    user: {},
    token: null,
    title: '',
    usertype: null,
    isLoggedin: false,
    loginuser: null
  },
  mutations: {
    [types.LOGIN_STATE]: (state, data) => {
      state.isLoggedin = data
    },
    [types.LOGIN_NAME]: (state, data) => {
      state.loginuser = data
    },
    [types.LOGIN]: (state, data) => {
      localStorage.token = data
      state.token = data
    },
    [types.LOGOUT]: (state) => {
      localStorage.removeItem('token')
      state.token = null
      state.isLoggedin = false
      state.loginuser = null
      state.usertype = null
    },
    [types.TITLE]: (state, data) => {
      state.title = data
    },
    [types.USERTYPE]: (state, data) => {
      state.usertype = data
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js